import Swiper from "../../node_modules/swiper/swiper-bundle.esm.browser";


let presentationSlider = new Swiper('.presentation-slider',{
    slidesPerView: 1,
    direction: "horizontal",
    spaceBetween:20,
    loop: true,
    speed:1000,
    pagination:{
        el:'.presentation-slider__pagination',
        type:'bullets',
        bulletClass:'bullet-white',
        bulletActiveClass:'bullet-white_active',
        clickable: true
    },
    navigation: {
        nextEl: '.presentation-slider-button-next',
        prevEl: '.presentation-slider-button-prev',
    },

})

let booksSlider = new Swiper('.books-slider',{
    slidesPerView: 1,
    centeredSlides: true,
    effect: 'fade',
    direction: "horizontal",
    spaceBetween:40,
    loop: true,
    speed:1000,
    pagination:{
        el:'.books-slider__pagination',
        type:'bullets',
        bulletClass:'bullet-black',
        bulletActiveClass:'bullet-black_active',
        clickable: true
    },
    navigation: {
        nextEl: '.books-slider-button-next',
        prevEl: '.books-slider-button-prev',
    },


})

let draftSlider = new Swiper('.draft-slider',{
    slidesPerView: 3,
    centeredSlides: true,
    centeredSlidesBounds: true,
    slideActiveClass:'active',
    loop: true,
    spaceBetween: 5,
    pagination:{
        el:'.draft-subslider__pagination',
        type:'bullets',
        bulletClass:'bullet-black',
        bulletActiveClass:'bullet-white_active',
        clickable: true
    },
    navigation: {
        nextEl: '.draft-slider-button-next',
        prevEl: '.draft-slider-button-prev',
    },
    breakpoints:{
        768:{
            slidesPerView: 3.7,
            spaceBetween: 55,
        },
        800:{
            slidesPerView:5,
            spaceBetween:35,
        }
    }
})

let draftSubSlider = new Swiper('.draft-subslider',{
    slidesPerView:1,
    slidesPerGroup:1,
    simulateTouch: false,
    allowTouchMove:false,
    noSwiping:true,
    effect:'fade',
    onlyExternal: true,
    speed:500,
    slideActiveClass:'animate__fadeIn animate__animated animate__faster active',

})

draftSlider.on('activeIndexChange',(e)=>{
    draftSubSlider.slideTo(e.realIndex,false)
})

let reviewSlider = new Swiper('.review-slider',{
    slidesPerView: 1,
    spaceBetween:16,
    pagination:{
        el:'.review-slider__pagination',
        type:'bullets',
        bulletClass:'bullet-black',
        bulletActiveClass:'bullet-white_active',
        clickable: true
    },
    speed: 800,
    navigation: {
        nextEl: '.review-slider-button-next',
        prevEl: '.review-slider-button-prev',
    },
})

let pagesSlider = new Swiper('.pages-slider',{
    slidesPerView: 1,
    spaceBetween:20,
    pagination:{
        el:'.pages-slider__pagination',
        type:'bullets',
        bulletClass:'bullet-black',
        bulletActiveClass:'bullet-white_active',
        clickable: true,

    },
    speed: 800,
    navigation: {
        nextEl: '.pages-slider-button-next',
        prevEl: '.pages-slider-button-prev',
    },

})

let informationSlider = new Swiper('.corridor-presentation__information-slider',{
    slidesPerView: 1,
    pagination:{
        el:'.corridor-presentation__information-pagination',
        type:'bullets',
        bulletClass:'bullet-white',
        bulletActiveClass:'bullet-white_active',
        clickable: true,
    },

})

let modalSlider = new Swiper('.modal-slider__slider',{
    slidesPerView: 1,
    navigation: {
        nextEl: '.modal-slider-button-next',
        prevEl: '.modal-slider-button-prev',
    },
    pagination:{
        el:'.modal-slider__pagination',
        type:'fraction',
    },
})

let modalSliderElem = document.querySelector('.modal__slider')
let modalSliderClose = document.querySelector('.modal-slider__close')
let tileImgArr = Array.from(document.querySelectorAll('.corridor-presentation__tile-link'))

if (modalSliderElem !== null){
    tileImgArr.forEach((tileImg, index)=>{
        tileImg.addEventListener('click',()=>{
            modalSlider.slideTo(index,1,false)
            modalSliderElem.classList.toggle('show')
        })
    })
    modalSliderClose.addEventListener('click',()=>{
        modalSliderElem.classList.toggle('show')
    })
}




let advantagesSlider = new Swiper('.club-advantages__slider',{
    slidesPerView: 1,
    pagination:{
        el:'.club-advantages__slider-pagination',
        type:'bullets',
        bulletClass:'bullet-black',
        bulletActiveClass:'bullet-white_active',
        clickable: true,
    },
    breakpoints:{
        1200:{


        }
    }
})

let seasonsSlider = new Swiper('.club-seasons__slider',{
    slidesPerView: 1,
    slideClass: 'club-seasons__slider-item',
    pagination:{
        el:'.club-seasons__slider-pagination',
        type:'bullets',
        bulletClass:'bullet-white',
        bulletActiveClass:'bullet-black_active',
        clickable: true,
    },
    breakpoints:{
        768:{
            slidesPerView: 3,
            spaceBetween:10,
        }
    }
})

